(function () {

    angular
        .module('smartertoolsApp')
        .service('downloadsService', ['$http', 'refreshToken', '$log', 'cacheControl', '$q', downloadsService]);

    function downloadsService($http, refreshToken, $log, cacheControl, $q) {
        var vm = this;
        vm.urlBase = apiRootUrl;

        // Functions
        vm.getAll = getAll;

        activate();

        // -----------------------------------------------

        function activate() {
        }

        function getAll() {
            return refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v1/build-downloads-complete', { cache: cacheControl.getCache('downloadsMailCache') }))
                .then((response) => response.data)
                .catch((err) => { $q.reject(err); });
        };
    }

})();